<template>
  <div id="app">
    <main v-if="loaded">
      <header>
        <h1> <span>The Brain Fuel<sup>&reg;</sup></span> Challenge Generator</h1> 
        <a href="https://challengegenerator.nl"> <i class="icon-flag"></i>Dutch</a>
      </header>
   


      <div class="controls">
            <button v-for="keuze in content.keuzemogelijkheden" :key="keuze.keuze.term_id" v-bind:class="keuze.keuze.slug"  class=" icon-arrows-cw" @click="setChallenge(keuze.keuze.term_id);"> {{ keuze.keuze.name }} </button>
        <!-- <button class="realistic icon-arrows-cw" @click="setChallenge(6);">Realistische Challenge</button>
        <button class="idiotic icon-arrows-cw" @click="setChallenge(7);">Idiote Challenge</button>
        <button class="world icon-arrows-cw" @click="setChallenge(8);">Red De Wereld</button> -->
        <button class="popup" @click="modal1 = !modal1">?</button>
      </div>    
       

      <section id="challenge">  
        <div class="challenge"> 
          <div class="buttons">
            <div :class="{'active': lock1 }" @click="lock1 = !lock1">
              <i :class="{ 'icon-lock': lock1, 'icon-lock-open': !lock1, 'active': lock1 }"></i> 
            </div>
            <div class="edit" @click="editable1 = !editable1;" :class="{ 'active': editable1 }"> 
              <i class="icon-edit"></i>
            </div>
          </div>

          <div class="text">
         

            <span 
            id="factorVoorvoegsel"
            ref="factorVoorvoegsel"
              contenteditable="true" 
              spellcheck="false"
              :class="[  editable1 ? 'editable' : '' ]" 
              @blur="inputfactorVoorvoegsel"
              @keydown="customFactor = true"
              @keydown.enter.prevent
              placeholder="(Hoe kunnen wij)"
              @click="editable1 = true;lock1=true"
              > 

              </span>
              &nbsp;
            <span 
            id="factor"
            ref="factor"
              contenteditable="true" 
              spellcheck="false"
              :class="[ challenge_type, editable1 ? 'editable' : '', customFactor ? 'custom' : '' ]" 
              @blur="inputChallenge"
              @keydown="customFactor = true"
              @keydown.enter.prevent
              placeholder="(challenge)"
              @click="editable1 = true;lock1=true"
              > 
           
              </span>
          </div>
        </div>

        <div class="challenge">
          <div class="buttons">
            <div :class="{'active': lock2 }" @click="lock2 = !lock2">
              <i :class="{ 'icon-lock': lock2, 'icon-lock-open': !lock2, 'active': lock2 }"></i> 
            </div>
            <div class="edit" @click="editable2 = !editable2;" :class="{ 'active': editable2 }"> 
              <i class="icon-edit"></i>
            </div>
          </div>
          <div class="text">
            
                        <span 
            id="onderwerpVoorvoegsel"
            ref="onderwerpVoorvoegsel"
              contenteditable="true" 
              spellcheck="false"
              :class="[  editable2 ? 'editable' : '' ]" 
              @blur="inputonderwerpVoorvoegsel"
              @keydown="customOnderwerp = true"
              @keydown.enter.prevent
              placeholder="(met behulp van)"
              @click="editable2 = true;lock2=true"
              > 

              </span>
              &nbsp;
 

            <span 
            id="onderwerp"
            ref="onderwerp"
              contenteditable="true" 
              :class="[  editable2 ? 'editable' : '', customOnderwerp ? 'custom' : '' ]" 
              spellcheck="false"
              @blur="inputOnderwerp"
              @keydown.enter.prevent
              placeholder="(middel)"
              @click="editable2 = true;lock2=true"
              > 
     
              </span>{{ this.leesteken }}
            </div>
        </div>
      </section>

      
      <div id="popups">
        <button class="grey" @click="modal2 = !modal2" > 
          I've got the solution
        </button>
        <button class="grey" @click="modal3 = !modal3" >
          Send in your own challenge
        </button>
      </div>


         
    </main>

    <footer  v-if="loaded">
      <div class="container">
        <a  class="logolink" href="https://brainfuel.nl" target="_blank">
        <img class="logo"  src="./assets/logo.svg" alt="">
        </a>
        <div class="text">
          <div v-html="content.footer"></div>
        </div>
        <div class="credit">
          <div v-html="content.inspiratie"></div>
    
        </div>
      </div>
    </footer>

    <div id="modal1" v-if="modal1 == true"  class="modal">
      <div class="modal-content">
        <span  @click="modal1 = !modal1" class="close">&times;</span>
            <div v-html="content.introductie"></div>
      </div>
    </div>

    <div id="modal2" v-if="modal2 == true"  class="modal">
      <div class="modal-content">
        <span  @click="modal2 = !modal2" class="close">&times;</span>
        <div v-html="content.oplossing"></div>
         
         <div class="form">

            <h4>
               {{ data['factor']['voorvoegsel'] }} &nbsp;
                <span :class="challenge_type" > 
                    {{  data['factor']['onderwerp']  }}
                </span>
                {{  data['onderwerp']['voorvoegsel']  }} &nbsp;
                <span 
                
                  > 
                  {{  data['onderwerp']['onderwerp']  }}
                  </span>
                  ?
            </h4>
          <input type="text" name="oplossing" v-model="solution">

          <label for="emailadres">E-mailadress</label>
          <input type="text" name="emailadres" v-model="email">

          <label for="naams">Name</label>
          <input type="text" name="naam" v-model="naam">

          <button @click="postSolution" class="rood submit">Send the solution</button>

        </div>
      </div>
    </div>

    <div id="modal3" v-if="modal3 == true"  class="modal">
      <div class="modal-content">
        <span  @click="modal3 = !modal3" class="close">&times;</span>
        <div v-html="content.insturen"></div>
        <!-- <h4>Jouw challenge:</h4> -->
        <div class="form">

           <div class="field">
             <select v-model="new_factorVoorvoegsel"> 
               <option selected>How might we</option>  
               <option>Design </option>  
               <option>Create</option>  
             </select>

            <input type="text" name="challenge"  placeholder="challenge" v-model="new_challenge"> 
           </div>
          

          <div class="field">
            <select v-model="new_onderwerpVoorvoegsel"> 
               <option selected>with help from</option>  
               <option>for</option>  
               <option>so that</option>  
             </select>
            <input type="text" name="onderwerp" placeholder="onderwerp" v-model="new_onderwerp">
          </div>
 
          <label for="emailadres">E-mailadress</label>
          <input type="text" name="emailadres" v-model="email">

          <label for="naams">Name</label>
          <input type="text" name="naam" v-model="naam">

          <button  @click="postChallenge" class="rood submit">Send in your challenge</button>

        </div>
      </div>
    </div>

    <div id="modal4" v-if="modal4 == true"  class="modal">
      <div class="modal-content">
        <span  @click="modal4 = !modal4" class="close">&times;</span>
        <div v-html="content.bevestiging_oplossing"></div>
          <button @click="modal4 = !modal4" class="rood submit">On to the next challenge</button>
      </div>
    </div>

    <div id="modal5" v-if="modal5 == true"  class="modal">
      <div class="modal-content">
        <span  @click="modal5 = !modal5" class="close">&times;</span>
        <div v-html="content.bevestiging_insturen"></div>
          <button @click="modal5 = !modal5" class="rood submit">On to the next challenge</button>
      </div>
    </div>
    </div>
 
  </div>
</template>     

<script>

const axios = require('axios');

export default {
  name: 'App',
  data() {
    return {
      content: null,
      data: null,

      factorVoorvoegsel: "Hoe kunnen wij",
      onderwerpVoorvoegsel: "met behulp van",
      onderwerp: null,
      challenge: null,
      challenge_type: null,
      editable1: false,
      editable2: false,
      leesteken: "?",
      customFactor: false,
      customOnderwerp: false,
      loaded: false,
      lock1: false,
      lock2: false,
      modal1: false,
      modal2: false,
      modal3: false,
      modal4: false,
      modal5: false,
      email: "",
      naam: "",
      solution: "",
      new_challenge: "",
      new_factorVoorvoegsel:"How might we",
      new_onderwerpVoorvoegsel:"with help from",
      new_onderwerp: "",
      
    }
  },
  mounted() { 
      fetch(process.env.VUE_APP_API+'/en/wp-json/v1/content')
         .then( response => response.json() )
        .then( (content ) => {
             
                this.content = content;
                this.setChallenge(this.content.keuzemogelijkheden[0].keuze.term_id);
        } )

  },
  methods: { 
    async getChallenge( id ) {
          await fetch(process.env.VUE_APP_API+'/en/wp-json/v1/challenge/'+id)
          .then( response => response.json() )
          .then( data => {
            if (
              !data['factor']['onderwerp'] ||
              !data['factor']['voorvoegsel'] ||
              !data['onderwerp']['onderwerp'] ||
              !data['onderwerp']['voorvoegsel'] 

            ) {
              // reset + log error
              this.getChallenge( id );
            }
    
            this.data   = data;
            this.loaded = true;
            this.challenge_type = "type-"+id;

          })
    },
    setFactor() { 
       this.$refs.factorVoorvoegsel.innerHTML = this.data['factor']['voorvoegsel'];
       this.$refs.factor.innerHTML   = this.data['factor']['onderwerp'];
       this.customFactor = false;
    },
    setOnderwerp() {
       this.$refs.onderwerpVoorvoegsel.innerHTML = this.data['onderwerp']['voorvoegsel'];
       this.$refs.onderwerp.innerHTML   = this.data['onderwerp']['onderwerp'];
       this.customOnderwerp = false;
    },


    setChallenge: function( id ) {

      this.solution = "";
      this.editable1 = false;
      this.editable2 = false;

     
      this.getChallenge( id ) 
      .then(() => {
        if ( !this.lock1 ) this.setFactor();
        if ( !this.lock2 ) this.setOnderwerp();
       
      } );

      // if ( this.tags.includes("noquestion")) this.leesteken ="."; else this.leesteken = "?"; 
      
    },

    async postSolution() {
          await axios({
            method: 'post',
            url: 'https://challengegenerator.nl/postSolution.php',
            data: {
              challenge: this. data['factor']['voorvoegsel']  +" "+ this. data['factor']['onderwerp']  +" "+ this. data['onderwerp']['voorvoegsel']  + " " + this. data['onderwerp']['onderwerp'] ,
              solution: this.solution,
              naam: this.naam,
              email: this.email,
              challenge_factor: this.challenge,
              onderwerp_factor: this.onderwerp
            }
          })
          this.modal2 = false;
          this.modal4 = true;
          this.solution = "";
    }, 

    async postChallenge() {

          await axios({
            method: 'post',
            url: 'https://challengegenerator.nl/postChallenge.php',
            data: {
              challenge: this.new_factorVoorvoegsel +" "+ this.new_challenge +" "+ this.new_onderwerpVoorvoegsel + " " + this.new_onderwerp,
               naam: this.naam,
              email: this.email
            }
          })
          this.new_factorVoorvoegsel = "Hoe kunnen wij";
          this.new_onderwerpVoorvoegsel = "met behulp van";
          this.modal3 = false;
          this.modal5 = true;
          this.new_challenge = "";
          this.new_onderwerp = "";
    },


    inputChallenge(e) {
      this.challenge = e.target.innerText;

    },
     inputOnderwerp(e) {
      this.onderwerp = e.target.innerText;
    },
     inputfactorVoorvoegsel(e) {
      this.factorVoorvoegsel = e.target.innerText;
    },
     inputonderwerpVoorvoegsel(e) {
      this.onderwerpVoorvoegsel = e.target.innerText;
    }

  


  }
}
</script>

<style lang="scss">
@import "style.scss"; 
</style>
